import { FC } from "react";

interface CalendarIconSVGProps {
    className?: string;
    fill?: string;
    onClick?: () => void;
}

const CalendarIconSVG: FC<CalendarIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            onClick={props.onClick}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill={props.fill || "transparent"}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.6667 2.66699V8.00033M21.3333 2.66699V8.00033M4 13.3337H28M6.66667 5.33366H25.3333C26.8061 5.33366 28 6.52757 28 8.00033V26.667C28 28.1398 26.8061 29.3337 25.3333 29.3337H6.66667C5.19391 29.3337 4 28.1398 4 26.667V8.00033C4 6.52757 5.19391 5.33366 6.66667 5.33366Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CalendarIconSVG;
